module.exports = __webpack_public_path__ + "img/empty-coop.0809d53e.svg";